import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./signupPage.style.css";
import "../app.css";
import Back from '../images/arrow-back.svg';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha"
import EmailValidator from 'email-validator'

import { useHistory } from "react-router-dom";

const recaptchaRef = React.createRef();

const SignUpPage = () => {

  const [submitted, setSubmitted] = useState(false);

  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [emailAddress, setEmailAddress] = useState();
  const [landlineNumber, setLandlineNumber] = useState();
  const [mobileNumber, setMobileNumber] = useState();
  const [accountNumber, setAccountNumber] = useState();
  const [valid, setValid] = useState(true);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const handleCaptureChange = (value) => {
    console.log("Captcha value:", value);
  }

  const onCancelBtnClick = () => {
    history.push("/");
  };

  const submitForm = () => {

    if (!firstname || !lastname || !emailAddress || !mobileNumber || !accountNumber) {
      alert("Please fill out all required fields")
      return;
    }

    var isEmailValid = EmailValidator.validate(emailAddress);

    if (!isEmailValid) {
      alert('Please check your email address')
      return;
    }

    if (mobileNumber.length < 10) {
      alert('Please check your mobile phone number')
      return;
    }

    setLoading(true)

    axios.post('https://k74aw66kta.execute-api.eu-west-2.amazonaws.com/dev/optout', {
      firstname: firstname,
      lastname: lastname,
      emailAddress: emailAddress,
      landlineNumber: landlineNumber,
      mobileNumber: mobileNumber,
      accountNumber: accountNumber
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        setSubmitted(true)
      })
      .catch(function (error) {
        setLoading(false)
        console.log(error);
      });


  };

  const submittedView = () => {
    if (!submitted) return
    return <div className="form-section">
      <h2>Thank you</h2>
      <p>We have received your request to opt out of the Warm Home Discount</p>
    </div>
  }

  const formView = () => {
    if (submitted) return;
    return <div className="form-section">
      <h2>Your personal details</h2>
      <div className="form-container">

        <form className="form">
          <div>
            <Form.Control value={firstname}
              validate
              required
              onChange={(e) => setFirstname(e.target.value)} size="lg" type="text" placeholder="First name" />
            <p>&nbsp;</p>
          </div>
          <div>
            <Form.Control value={lastname}
              validate
              required
              onChange={(e) => setLastname(e.target.value)} size="lg" type="text" placeholder="Last name" />
            <p>&nbsp;</p>
          </div>
          <div>
            <Form.Control value={mobileNumber}
              validate
              required
              onChange={(e) => setMobileNumber(e.target.value)} size="lg" type="text" placeholder="Mobile number" />
            <p>&nbsp;</p>
          </div>
          <div>
            <Form.Control value={landlineNumber}
              validate
              required
              onChange={(e) => setLandlineNumber(e.target.value)} size="lg" type="text" placeholder="Landline number" />
            <p>Optional</p>
          </div>
          <div>
            <Form.Control value={emailAddress}
              validate
              required
              onChange={(e) => setEmailAddress(e.target.value)} size="lg" type="text" placeholder="Email address" />
            <p>&nbsp;</p>
          </div>
          <div>
            <Form.Control value={accountNumber}
              validate
              required
              onChange={(e) => setAccountNumber(e.target.value)} size="lg" type="text" placeholder="EDF account number" />
            <p>&nbsp;</p>
          </div>
        </form>

        <div className="rightSide">
          <div className="opt-out-info">
            <h3>Keep in mind!</h3>
            <p>This is for people who may have signed up by mistake and are not eligible for the discount</p>
          </div>
        </div>
      </div>
      <div className="btn-container">
        <Button disabled={loading} className="dark-btn-whd" onClick={submitForm}>
          {loading ?
            <p>Processing...</p>
            : "Submit"
          }
        </Button>
      </div>
    </div>
  }


  useEffect(() => {

  }, []);

  return (
    <>

      <Header />

      <div className="opt-out-landing-body">
        <div className="sub-nav-container">
          <div className="signup-btn-div">
            <Button onClick={onCancelBtnClick} className="signup-btn learn-btn">
              <img src={Back} /> Back
            </Button>
          </div>
        </div>
        <h1 className="hero-title">
          Fill out the form to opt out of the Warm Home Discount
        </h1>
      </div>


      {formView()}
      {submittedView()}

      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey="6LcMisAcAAAAACTTDJvsk4tG38izf89IZNN8TIip"
        onChange={handleCaptureChange}
        size="invisible"
      />

      <Footer />
    </>
  );
};
export default SignUpPage;

